import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Navigate } from 'react-router-dom';
import { useRequireOrganization } from '../../hooks/useRequireOrganization.js';
import { PageContainer } from '../page-layout/PageContainer.js';
import { Skeleton } from '../ui/skeleton.js';

/**
 * Route wrapper that requires the user to be in an organization context.
 * Redirects personal accounts (no organization context) to /home (the mobile app page).
 */
function RequireOrganization({ children }) {
    const { hasOrganization, isLoading } = useRequireOrganization();
    // Show loading state while checking organization context
    if (isLoading) {
        return (jsx(PageContainer, { children: jsxs("div", { className: "space-y-4", children: [jsx(Skeleton, { className: "h-8 w-64" }), jsx(Skeleton, { className: "h-64 w-full" })] }) }));
    }
    // Redirect to home page if user is not in an organization context
    if (!hasOrganization) {
        return jsx(Navigate, { to: "/home", replace: true });
    }
    // User is in organization context - render the protected content
    return jsx(Fragment, { children: children });
}

export { RequireOrganization };
//# sourceMappingURL=RequireOrganization.js.map
